<template>
  <b-tabs
    v-if="isReady"
    v-model="activeTab"
    lazy
  >
    <b-tab
      v-if="$hasPermission('view_publisher_details')"
    >
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('usersettings.publisherDetails') }}</span>
      </template>
      <publisher-details
        :profile="profile"
        :countries="countries"
        :read-only="!$hasPermission('update_publisher_details')"
        @refresh-profile="refreshProfile()"
      />
    </b-tab>

    <b-tab>
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('usersettings.security') }}</span>
      </template>
      <user-settings-change-password
        :profile="profile"
        @refresh-profile="refreshProfile()"
      />
    </b-tab>

    <b-tab v-if="$hasPermission('update_payment_details')">
      <template #title>
        <feather-icon
          icon="InfoIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('usersettings.payment') }}</span>
      </template>
      <user-settings-payment
        :profile="profile"
        @refresh-profile="refreshProfile()"
      />
    </b-tab>

    <b-tab v-if="$hasPermission('update_mail_settings')">
      <template #title>
        <feather-icon
          icon="LinkIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('usersettings.eMailReports') }}</span>
      </template>
      <user-settings-email-report
        :profile="profile"
        @refresh-profile="refreshProfile()"
      />
    </b-tab>

    <b-tab v-if="canSeeUsers">
      <template #title>
        <feather-icon
          icon="UsersIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('usersettings.users') }}</span>
      </template>
      <publisher-users
        :profile="profile"
        @refresh-profile="refreshProfile()"
      />
    </b-tab>

    <b-tab v-if="canSeeRoles">
      <template #title>
        <feather-icon
          icon="ShieldIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('usersettings.roles') }}</span>
      </template>
      <publisher-roles />
    </b-tab>

    <b-tab v-if="isOwnerAccount">
      <template #title>
        <feather-icon
          icon="KeyIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('usersettings.reportingApiKey') }}</span>
      </template>
      <reporting-api-key />
    </b-tab>

  </b-tabs>
</template>

<script>
import i18n from '@/libs/i18n'

import PublisherDetails from '@/views/user-settings/PublisherDetails.vue'
import UserSettingsChangePassword from './UserSettingsChangePassword.vue'
import UserSettingsPayment from './UserSettingsPayment.vue'
import UserSettingsEmailReport from './UserSettingsEmailReport.vue'
import PublisherUsers from './PublisherUsers.vue'
import PublisherRoles from './PublisherRoles.vue'
import ReportingApiKey from './ReportingApiKey.vue'

export default {
  components: {
    PublisherDetails,
    UserSettingsChangePassword,
    UserSettingsPayment,
    UserSettingsEmailReport,
    PublisherUsers,
    PublisherRoles,
    ReportingApiKey,
    // CustomVsTab,
  },
  data() {
    return {
      profile: null,
      isReady: false,
      countries: [],
      activeTab: 0,
      activeTabName: 'details',
    }
  },
  computed: {
    canSeeRoles() {
      return this.$hasPermission('view_roles') || this.$hasPermission('manage_roles')
    },
    canSeeUsers() {
      return this.$hasPermission('view_users') || this.$hasPermission('manage_users')
    },
    isOwnerAccount() {
      return this.$store.getters['auth/isOwner']
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    },
  },
  created() {
    this.showLoading()
    this.$http.get('/api/profile-settings/get').then(response => {
      this.profile = response.data.profile
      this.countries = response.data.countries
      this.isReady = true
    }).catch(errors => {
      this.alertApiError(errors, i18n.t('usersettings.failedToLoadProfile'))
      this.isReady = true
    }).finally(() => {
      this.hideLoading()
    })
  },
  methods: {
    async refreshProfile() {
      try {
        // Re-fetch the full profile (including the now-synced publisher email)
        const response = await this.$http.get('/api/profile-settings/get')

        // Update the local object. Because we replace the object reference,
        // the 'watch' in PublisherDetails child will trigger.
        this.profile = { ...response.data.profile }

        // Also update countries just in case
        this.countries = response.data.countries
      } catch (error) {
        this.alertApiError(error, i18n.t('usersettings.failedToRefreshProfileData'))
      }
    },
  },
}
</script>
